// src/components/PinModal.jsx
import React, { useEffect, useState } from 'react';
import api from '../services/api';

function PinModal({ perfil, onConfirm, onCancel }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (/^[0-9]$/.test(e.key)) {
        if (pin.length < 10) setPin((prev) => prev + e.key);
      } else if (e.key === 'Backspace') {
        setPin((prev) => prev.slice(0, -1));
      } else if (e.key === 'Enter') {
        validarPin();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [pin]);

  const agregarDigito = (digito) => {
    if (pin.length < 10) {
      setPin(pin + digito);
      setError('');
    }
  };

  const borrar = () => {
    setPin(pin.slice(0, -1));
  };

  const validarPin = async () => {
    try {
      const res = await api.post('/perfiles/validar-pin', {
        perfilId: perfil.id,
        pin
      });

      if (res.data.validado) {
        onConfirm(res.data.perfil); // Perfil actualizado desde la base de datos
      }
    } catch (err) {
      console.error(err);
      setError('PIN incorrecto');
      setPin('');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <img
          src={`/avatars/${perfil.avatar || 'default.png'}`}
          alt="avatar"
          style={styles.avatar}
        />
        <h3 style={styles.nombre}>Introduce el PIN para {perfil.nombre}</h3>

        <input
          type="password"
          value={pin}
          readOnly
          style={styles.input}
          placeholder="PIN"
        />

        <div style={styles.teclado}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num) => (
            <button key={num} onClick={() => agregarDigito(num)} style={styles.boton}>
              {num}
            </button>
          ))}
          <button onClick={borrar} style={styles.boton}>←</button>
          <button onClick={validarPin} style={styles.boton}>OK</button>
        </div>

        {error && <p style={styles.error}>{error}</p>}

        <button onClick={onCancel} style={styles.cerrar}>Cancelar</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    zIndex: 9999
  },
  modal: {
    backgroundColor: '#222',
    padding: '30px',
    borderRadius: '12px',
    color: 'white',
    textAlign: 'center',
    minWidth: '280px'
  },
  avatar: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '10px',
    border: '2px solid white'
  },
  nombre: {
    margin: 0,
    fontSize: '1.2rem',
    marginBottom: '15px'
  },
  input: {
    fontSize: '1.5rem',
    padding: '10px',
    width: '100%',
    marginBottom: '15px',
    borderRadius: '6px',
    textAlign: 'center',
    border: '1px solid #555',
    background: '#111',
    color: '#fff'
  },
  teclado: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
    marginBottom: '15px'
  },
  boton: {
    padding: '15px',
    fontSize: '1.2rem',
    backgroundColor: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  error: {
    color: 'red',
    marginBottom: '10px'
  },
  cerrar: {
    backgroundColor: '#555',
    color: 'white',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  }
};

export default PinModal;
